$(document).ready(function () {
    //messagesGetMessagesUnread();
});

function messagesGetMessagesUnread() {
    // Préparation de l'url
    var filters = {
        status: 'unread',
    };
    var ajaxUrl = '/api/messagerie/messages?filters=' + JSON.stringify(filters);

    // Récupération des messages
    $.ajax({
        type: 'GET',
        url: ajaxUrl
    }).done(function (response) {
        var total = response.total;
        if (response.total == 1) {
            $('button', '.header-messages-unread-count').html(total + ' <span class="icon icon-mail icon-smaller col p-2"></span>');
            $('.header-messages-unread-count').removeClass('d-none');
            $('.menuleft-messages-unread-count').html('(' + total + ')');
            $('.menuleft-messages-unread-count').removeClass('d-none');
        } else if (response.total > 1) {
            $('button', '.header-messages-unread-count').html(total + ' <span class="icon icon-mail icon-smaller col p-2"></span>');
            $('.header-messages-unread-count').removeClass('d-none');
            $('.menuleft-messages-unread-count').html('(' + total + ')');
            $('.menuleft-messages-unread-count').removeClass('d-none');
        } else {
            $('button', '.header-messages-unread-count').html('0 <span class="icon icon-mail icon-smaller col p-2"></span>');
            $('.header-messages-unread-count').addClass('d-none');
            $('.menuleft-messages-unread-count').html('0');
            $('.menuleft-messages-unread-count').addClass('d-none');
        }
    });
}
